import { useEffect, useState } from "react";

import { getJobApplicants } from "../api/candidates.api";
import { JobApplicantsResponse } from "../types";

export default function useJobApplicants(jobId?: string) {
  const [data, setData] = useState<JobApplicantsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchApplicants = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getJobApplicants(jobId);

        if (!cancelled) {
          setData(response.data.data);
        }
      } catch (fetchError: unknown) {
        console.error("Error fetching applicants:", fetchError);

        if (!cancelled) {
          setError("Unable to load applicants.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchApplicants();

    return () => {
      cancelled = true;
    };
  }, [jobId]);

  return { data, loading, error };
}
